export enum QuestionFormType {
  CHOICE = 'choice',
  CHECKBOX_RADIO = 'checkboxRadio',
}
